module.exports = __webpack_public_path__ + "img/bracket-bg-2.2356f32c.png";